var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'suggestions-subnav',
        !_vm.inDashboard && 'suggestions-subnav-padded',
    ]},_vm._l((_vm.navMap),function({ mode, label }){return _c('RouterLink',{key:mode,attrs:{"to":`${_vm.currentPath}/${mode}`,"tag":"span","replace":""}},[_c('button',{staticClass:"btn filter-btn",class:{
                'filter-btn-active': mode === _vm.activeMode,
                'filter-btn-inactive': mode !== _vm.activeMode,
            }},[_vm._v(" "+_vm._s(label)+" ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }